exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".IconClose_iconClose__1gDux{cursor:pointer;margin-top:3px}.IconClose_iconClose__1gDux:hover{fill:#c2c2c2}.IconClose_iconClose__1gDux:active{fill:#999}", ""]);

// exports
exports.locals = {
	"iconClose": "IconClose_iconClose__1gDux"
};